import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from 'moment'
import Edit from '@material-ui/icons/Edit'

export default class PhoneLogs extends Framework.Components.Collection {
	constructor(props) {

		let model = new API.BuildClass(Types.Phone_Logs._name, API.RequestType.READ_ALL);
		super(props,model);
		this.state.limit = 16;
	}

	fetchData = async (state) => {
		if (this.props.isModal) {
			this.state.limit = 10;
			this.limit = 10;
		}
		if (typeof(this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		if (this.props.filter) {

			this.state.filter.filterTFO = this.props.filter.filterTFO
			this.state.filter.filterByRecent = this.props.filter.filterByRecent
			this.state.filter.filterRegion = this.props.filter.filterRegion
		}
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = this.props.filter ?
			[
				{
					Header: "Date",
					id: "created",
					width: 110,
					/** @param {Phone_Logs_Object} obj */
					accessor: obj => moment(obj.created).local().format("MM/DD/YYYY")
				},
				{
					Header: "Phone Number",
					id: "phone_number",
					width: 130,
					/** @param {Phone_Logs_Object} obj */
					accessor: obj => (obj.phone_number)
				},
				{
					Header:"Region",
					id: "regions.name",
					accessor: obj => (obj.regions.name)
				},
				{
					Header:"ZIP",
					id: "zip",
					width: 80,
					accessor: obj => (obj.zip),
					Cell: (props) => {
						if (!props.original.zip) {
							return (
								<span>N/A</span>
							);
						}

						return (
							<span>
								<a href={`https://www.google.com/maps/dir/${props.original.zip}`} target={"_blank"}>
									{props.original.zip}
								</a>
							</span>
						);
					}
				},
				{
					Header: "Notes",
					id: "notes",
					accessor: obj => (obj.notes)
				},
				{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					Cell: props => {
						return (
							<span>
								<Link to={`/phone/${props.original.pkey}`} target={"_blank"}>
									<Button color="green-meadow" size={"sm"} block={true}>
										<Edit fontSize={'small'}/></Button>
								</Link>
							</span>
						);
					}
				}
			] : [
				{
					Header: "Date",
					id: "created",
					/** @param {Phone_Logs_Object} obj */
					accessor: obj => moment(obj.created).local().format("MM/DD/YYYY")
				},
				{
					Header: "Phone Number",
					id: "phone_number",
					/** @param {Phone_Logs_Object} obj */
					accessor: obj => (obj.phone_number)
				},
				{
					Header: "User",
					id: "user", // Can't use users.name_last since it's a virtual column
					/** @param {Phone_Logs_Object} obj */
					accessor: obj => (obj.users.name_first + ' ' + obj.users.name_last)
				},
				{
					Header:"Region",
					id: "regions.name",
					accessor: obj => (obj.regions.name)
				},

				{
					Header: "Zip",
					accessor:"zip"

				},
				{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					Cell: props => {
						return (
							<span>
								<Link to={`/phone/${props.original.pkey}`} target={"_blank"}>
									<Button color="green-meadow" size={"sm"} block={true}>
										<Edit fontSize={'small'}/></Button>
								</Link>
							</span>
						);
					}
				}
			]

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Phone Logs')}
							{this.renderHeaderRight("Phone_Logs", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSizeOptions={[5, 10, 15, 20, 50]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
